import React from 'react';
import { Button } from './ui/Button';
import { Divider } from './ui/Divider';
import { ShieldCheckIcon, Zap } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="bg-cream py-24 px-6" data-id="element-58">
      <div className="max-w-3xl mx-auto text-center" data-id="element-59">
        <h2 className="text-4xl md:text-5xl mb-6" data-id="element-60">The Price</h2>
        <Divider className="mb-8" data-id="element-61" />

        <div className="bg-white p-10 md:p-16 rounded-[2.5rem] shadow-xl border border-sage/10 relative overflow-hidden" data-id="element-62">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-sage via-olive-light to-sage" data-id="element-63"></div>

          <p className="text-lg text-warm-dark/60 mb-4 uppercase tracking-widest font-bold" data-id="element-64">
            You won't pay the standard price
          </p>

          <div className="flex items-center justify-center gap-6 mb-6" data-id="element-65">
            <span className="text-4xl md:text-5xl text-warm-dark/30 line-through font-heading decoration-sage/50" data-id="element-66">
              $57.00
            </span>
            <span className="text-6xl md:text-7xl font-heading text-olive-gold font-bold" data-id="element-67">
              $6.36
            </span>
          </div>

          <div className="inline-flex items-center gap-2 bg-olive-gold/10 border border-olive-gold/20 rounded-full px-5 py-2.5 mb-8" data-id="element-68">
            <Zap className="w-4 h-4 text-olive-gold fill-olive-gold" data-id="element-69" />
            <span className="text-sm font-bold text-olive-gold uppercase tracking-wider" data-id="element-70">
              Today Only: Instant Download for $6.36 — Regular Price $57
            </span>
          </div>

          <p className="text-xl text-olive-light font-heading italic mb-10" data-id="element-71">
            You get the full protocol today.
          </p>

          <Button className="w-full md:w-auto md:px-12 py-6 text-lg shadow-xl shadow-olive-light/20" data-id="element-72">
            YES! I WANT THE PROTOCOL
          </Button>
          <p className="mt-6 text-sm text-warm-dark/50 uppercase tracking-widest font-bold" data-id="element-73">
            Instant Digital Download
          </p>

          <div className="mt-10 pt-8 border-t border-sage/10" data-id="element-74">
            <div className="flex flex-col items-center gap-3" data-id="element-75">
              <div className="w-14 h-14 rounded-full bg-sage-light flex items-center justify-center" data-id="element-76">
                <ShieldCheckIcon className="w-7 h-7 text-sage" data-id="element-77" />
              </div>
              <h3 className="text-lg font-heading font-bold text-warm-dark uppercase tracking-wider" data-id="element-78">
                7-Day Money-Back Guarantee
              </h3>
              <p className="text-warm-dark/70 max-w-md leading-relaxed text-sm" data-id="element-79">
                Try the full protocol risk-free. If you don't feel a real
                difference in your energy, sleep, or clarity within 7 days, just
                send us a message and we'll refund every penny — no questions
                asked.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}